import { changeEmailApiV1AuthChangeEmailPost } from '@/common/api/client/sdk.gen'
import type {
    ChangeEmailApiV1AuthChangeEmailPostError,
    ChangeEmailApiV1AuthChangeEmailPostResponse,
    ChangeEmailRequest,
} from '@/common/api/client/types.gen'
import { useFormMutation } from '@/common/hooks/useFormMutation'
import { useQueryClient } from '@tanstack/react-query'

/** Бэкенд change-email пока не описывает поле в схеме, но уже принимает его в body. */
type ChangeEmailFormData = ChangeEmailRequest & {
    subscribe_marketing?: boolean
    terms_of_service?: boolean
}

export const useChangeEmailModel = () => {
    const queryClient = useQueryClient()

    const { form, mutation, handleSubmit, register, errors, isLoading, isSuccess, isError, error, onSubmit } =
        useFormMutation<
            ChangeEmailFormData,
            ChangeEmailApiV1AuthChangeEmailPostResponse,
            ChangeEmailApiV1AuthChangeEmailPostError
        >({
            mutationFn: data =>
                changeEmailApiV1AuthChangeEmailPost({
                    body: data as ChangeEmailRequest,
                }).then(res => res.data!),
            toastOptions: {
                successMessage: (_data, formData) => `Письмо с подтверждением отправлено на ${formData.email}`,
                errorMessage: 'Ошибка при отправке подтверждения почты',
            },
            formOptions: {
                defaultValues: {
                    email: '',
                    subscribe_marketing: false,
                    terms_of_service: false,
                },
            },
            onSuccess: updatedProfile => {
                queryClient.setQueryData(['me'], updatedProfile)
            },
        })

    return {
        form,
        changeEmail: mutation,
        handleSubmit,
        onSubmit,
        register,
        errors,
        isPending: isLoading,
        isSuccess,
        isError,
        error,
    }
}
